module.exports = __webpack_public_path__ + "img/detailedlist_20pt.a81749bf.svg";